
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9Eka4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a4skX = parcelRequire("a4skX");


var $i3S9F = parcelRequire("i3S9F");


var $kwzZh = parcelRequire("kwzZh");


var $6oMcp = parcelRequire("6oMcp");


var $8Pm8w = parcelRequire("8Pm8w");


var $kyaLk = parcelRequire("kyaLk");


var $9DHhW = parcelRequire("9DHhW");


var $imQxZ = parcelRequire("imQxZ");


var $5I78X = parcelRequire("5I78X");


var $4yccB = parcelRequire("4yccB");


var $isuYJ = parcelRequire("isuYJ");


var $9wGTI = parcelRequire("9wGTI");


var $6GQtz = parcelRequire("6GQtz");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $4IoVL = parcelRequire("4IoVL");


var $iP9x4 = parcelRequire("iP9x4");


var $dPJCf = parcelRequire("dPJCf");


var $60cDW = parcelRequire("60cDW");


var $32x2E = parcelRequire("32x2E");


var $gsPOZ = parcelRequire("gsPOZ");


var $kr7vV = parcelRequire("kr7vV");


var $epn2u = parcelRequire("epn2u");

const $4a3ff359f5c9274c$export$6af91131bd465ca7 = (cloudId, userId, spaceKey)=>{
    return (0, $cozmU.useMemo)(()=>({
            createEmojiProvider: ()=>{
                return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                    cloudId: cloudId,
                    userId: userId || undefined,
                    allowAnonymousAccess: true
                });
            },
            createMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                return (0, $4IoVL.createRendererMediaProvider)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false
                });
            },
            createSSRMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                const mediaClientConfig = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false,
                    spaceKey: spaceKey
                });
                if (mediaClientConfig) // Return config for both server (SSR) and client (post-hydration) so synced block
                // media uses the source contentId for auth, not the current page's contentId.
                return {
                    viewMediaClientConfig: mediaClientConfig.config
                };
                return undefined;
            },
            // Uses the same logic as in preloadEditorNodeDataProvidersData.ts
            createSmartLinkProvider: ()=>{
                const { host: host, cloudId: ssrCloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
                const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
                if (objectResolverURL) {
                    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
                    ssrCardClient.setHeaders({
                        Cookie: (0, $jQQYu.createCookie)(userContext),
                        Origin: host.startsWith('http') ? host : `https://${host}`,
                        CloudId: ssrCloudId || cloudId
                    });
                    return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient));
                }
                return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
            }
        }), [
        cloudId,
        userId,
        spaceKey
    ]);
};
const $4a3ff359f5c9274c$export$3033656cbf649a98 = ({ contentId: confluencePageId, contentType: contentType })=>{
    // `SessionDataContext` has no default value. The Table of Contents calls this hook on every
    // render, including the editor's SSR pass, which renders each node view through an isolated
    // `renderToStaticMarkup` with no Confluence providers. Destructuring `undefined` there throws,
    // the editor swallows the error and leaves the server-rendered TOC empty (HOT-306707).
    const sessionData = (0, $bQm3c.useSessionData)();
    const cloudId = sessionData?.cloudId ?? '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const confluencePageAri = (0, $cozmU.useMemo)(()=>confluencePageId ? (0, $6oMcp.getConfluencePageAri)({
            pageId: confluencePageId,
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }) : undefined, [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $8Pm8w.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId
    });
    const relayFetchProvider = (0, $cozmU.useMemo)(()=>(0, $gsPOZ.createRelaySyncBlockFetchProvider)(blockServiceFetchProvider, cloudId), [
        blockServiceFetchProvider,
        cloudId
    ]);
    // The TOC only reads content, but the synced-block provider still needs its
    // write provider to derive reference resource ids when same-page sync is
    // enabled. Supplying it here does not perform any writes.
    const readOnlyProviderOptions = (0, $cozmU.useMemo)(()=>({}), []);
    const syncedBlockProvider = (0, $kyaLk.useMemoizedSyncedBlockProvider)({
        fetchProvider: (0, $6mKj3.expValEquals)('platform_editor_sync_block_renderer_no_realtime', 'isEnabled', true) ? blockServiceFetchProvider : relayFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: readOnlyProviderOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    const handleSyncedBlockAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: payload
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    // The Table of Contents reads from the same store as the reference blocks on
    // the view page, so it follows the renderer's refresh model: headings as of
    // page load.
    const storeManager = (0, $5I78X.useMemoizedSyncBlockStoreManager)(syncedBlockProvider, handleSyncedBlockAnalyticsEvent, (0, $6mKj3.expValEquals)('platform_editor_sync_block_renderer_no_realtime', 'isEnabled', true) ? {
        enableRealTimeSubscriptions: false
    } : undefined);
    // Without session data there is no cloudId to build ARIs from, so there is nothing the TOC
    // could usefully subscribe to. Returning `undefined` makes the caller render no subscribers.
    return confluencePageId && sessionData ? storeManager : undefined;
};
const $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled = ({ doc: doc, spaceKey: spaceKey, contentId: confluencePageId, contentType: contentType, mergedDataProviderDefinitions: mergedDataProviderDefinitions, stickyHeadersConfig: stickyHeadersConfig, contentMode: contentMode })=>{
    const syncBlockNodes = (0, $cozmU.useMemo)(()=>{
        return (0, $imQxZ.getSyncBlockNodesFromDoc)(doc);
    }, [
        doc
    ]);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluencePageAri = (0, $cozmU.useMemo)(()=>confluencePageId ? (0, $6oMcp.getConfluencePageAri)({
            pageId: confluencePageId,
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }) : undefined, [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $8Pm8w.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId
    });
    const relayFetchProvider = (0, $cozmU.useMemo)(()=>(0, $gsPOZ.createRelaySyncBlockFetchProvider)(blockServiceFetchProvider, cloudId), [
        blockServiceFetchProvider,
        cloudId
    ]);
    const syncedBlockNestedRendererProviderCreator = $4a3ff359f5c9274c$export$6af91131bd465ca7(cloudId, userId, spaceKey);
    const providerOptions = (0, $cozmU.useMemo)(()=>{
        return {
            parentDataProviders: {
                ...mergedDataProviderDefinitions
            },
            providerCreator: syncedBlockNestedRendererProviderCreator
        };
    }, [
        mergedDataProviderDefinitions,
        syncedBlockNestedRendererProviderCreator
    ]);
    const syncedBlockProvider = (0, $kyaLk.useMemoizedSyncedBlockProvider)({
        fetchProvider: (0, $6mKj3.expValEquals)('platform_editor_sync_block_renderer_no_realtime', 'isEnabled', true) ? blockServiceFetchProvider : relayFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: providerOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    const handleSyncedBlockAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: payload
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $cozmU.useMemo)(()=>{
        return (0, $kr7vV.createSmartCardEventHandler)({
            matchRoute: matchRoute,
            push: push
        });
    }, [
        matchRoute,
        push
    ]);
    // When the synced-block ToC experiment is on, enable heading anchor links
    // inside synced blocks. We intentionally do NOT provide a `getHeadingLink`
    // override: omitting it makes the renderer fall back to the platform default
    // (current view page URL + hash), which matches the copy-link behaviour of
    // every other heading on the page.
    const allowHeadingAnchorLinks = (0, $cozmU.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_toc_synced_block_exp', 'isEnabled', true) ? {
            allowNestedHeaderLinks: true
        } : undefined, []);
    // An inline object gives the memoised node component a new identity each render,
    // remounting the subtree and destroying any in-progress text selection.
    const memoizedSyncBlockRendererOptions = (0, $cozmU.useMemo)(()=>({
            smartLinks: {
                ssr: true
            },
            eventHandlers: syncedBlockEventHandlers,
            stickyHeaders: stickyHeadersConfig ? {
                show: true,
                ...stickyHeadersConfig
            } : {
                show: true,
                offsetTop: 0
            },
            contentMode: contentMode,
            allowHeadingAnchorLinks: allowHeadingAnchorLinks
        }), [
        syncedBlockEventHandlers,
        stickyHeadersConfig,
        contentMode,
        allowHeadingAnchorLinks
    ]);
    const SyncedBlockNodeComponent = (0, $imQxZ.useMemoizedSyncedBlockNodeComponent)({
        syncBlockProvider: syncedBlockProvider,
        syncBlockNodes: syncBlockNodes,
        // This hook only backs the classic renderer (`ADFRendererComponent`); the
        // editor and live docs build their providers in `editor-features`, so this
        // leaves those surfaces live.
        enableRealTimeSubscriptions: (0, $6mKj3.expValEquals)('platform_editor_sync_block_renderer_no_realtime', 'isEnabled', true) ? false : undefined,
        syncBlockRendererOptions: (0, $9wGTI.fg)('platform_editor_blocks_patch_7') ? memoizedSyncBlockRendererOptions : {
            smartLinks: {
                ssr: true
            },
            eventHandlers: syncedBlockEventHandlers,
            stickyHeaders: stickyHeadersConfig ? {
                show: true,
                ...stickyHeadersConfig
            } : {
                show: true,
                offsetTop: 0
            },
            contentMode: contentMode,
            allowHeadingAnchorLinks: // Must be forwarded on this branch too. `allowHeadingAnchorLinks`
            // is gated by its own `confluence_toc_synced_block_exp` experiment,
            // so it must not be coupled to `platform_editor_blocks_patch_7`
            // (an unrelated editor patch gate that only controls whether the
            // options object is memoised). Omitting it here leaves the renderer
            // with no anchor-link config whenever that patch gate is off, which
            // disables heading ids inside synced blocks — breaking ToC deep
            // links — and hides the heading copy-link button.
            allowHeadingAnchorLinks
        },
        fireAnalyticsEvent: handleSyncedBlockAnalyticsEvent
    });
    // If confluencePageId is undefined, don't return the synced block node component, and don't render synced blocks
    return confluencePageId ? SyncedBlockNodeComponent : undefined;
};
const $4a3ff359f5c9274c$export$27db3e01691a7a01 = (_props)=>{
    return undefined;
};
const $4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud = ()=>{
    return (0, $a4skX.isFedrampModerate)() || (0, $i3S9F.isIsolatedCloud)();
};
const $4a3ff359f5c9274c$export$e8874f89f60efbe6 = (0, $isuYJ.conditionalHooksFactory)(()=>!$4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud(), $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled, $4a3ff359f5c9274c$export$27db3e01691a7a01);
module.exports["useMemoizedSyncedBlockNestedRendererProviderCreator"] = $4a3ff359f5c9274c$export$6af91131bd465ca7;
module.exports["useSyncBlockStoreManagerForContent"] = $4a3ff359f5c9274c$export$3033656cbf649a98;
module.exports["useMemoizedSyncedBlockProviderNodeComponent"] = $4a3ff359f5c9274c$export$e8874f89f60efbe6;

});

parcelRegister("kyaLk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3xsB6 = parcelRequire("3xsB6");


var $6oMcp = parcelRequire("6oMcp");


var $fRKL0 = parcelRequire("fRKL0");


var $83vgd = parcelRequire("83vgd");


var $79ir6 = parcelRequire("79ir6");


var $PkUFx = parcelRequire("PkUFx");

class $0b95be1fc334e182$export$ead9a287a0b743c7 extends (0, $PkUFx.SyncBlockDataProviderInterface) {
    setProviderOptions(providerOptions) {
        this.providerOptions = providerOptions;
    }
    /**
   * Check if the node is supported by the provider
   *
   * @param node
   *
   * @returns True if the node is supported, false otherwise
   */ isNodeSupported(node) {
        return node.type === 'syncBlock' || node.type === 'bodiedSyncBlock';
    }
    /**
   * Get the data key for the node
   *
   * @param node
   *
   * @returns The data key
   */ nodeDataKey(node) {
        return node.attrs.resourceId;
    }
    /**
   * Fetch the data from the fetch provider using batch API
   *
   * @param nodes
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async fetchNodesData(nodes) {
        const blockIdentifiers = nodes.map((node)=>({
                resourceId: node.attrs.resourceId,
                blockInstanceId: node.attrs.localId
            }));
        if (blockIdentifiers.length === 0) return [];
        try {
            return await this.fetchProvider.batchFetchData(blockIdentifiers);
        } catch  {
            // If batch fetch fails, fall back to individual fetch behavior
            // This allows loading states to be shown before errors, matching non-batch behavior
            return Promise.allSettled(blockIdentifiers.map((blockIdentifier)=>{
                return this.fetchProvider.fetchData(blockIdentifier.resourceId).then((data)=>{
                    return data;
                }, (error)=>{
                    return {
                        error: {
                            type: (0, $79ir6.SyncBlockError).Errored,
                            reason: error
                        },
                        resourceId: blockIdentifier.resourceId
                    };
                });
            })).then((results)=>{
                return results.filter((result)=>{
                    return result.status === 'fulfilled';
                }).map((result)=>result.value);
            });
        }
    }
    /**
   * Write the data to the write provider
   *
   * @param nodes
   * @param data
   *
   * @returns Array of {resourceId?: string, error?: string}.
   * resourceId: resource id of the node if write successfully , error: reason for when write failed
   */ async writeNodesData(nodes, data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        // Use batch write only when method is available
        if (this.writeProvider.writeDataBatch) {
            // Separate data into valid (with content) and invalid (without content)
            const validDataWithIndices = [];
            const invalidResults = [];
            data.forEach((blockData)=>{
                if (blockData.content) validDataWithIndices.push(blockData);
                else invalidResults.push({
                    error: 'No Synced Block content to write',
                    resourceId: blockData.resourceId
                });
            });
            // Process valid data in batch
            let batchResults = [];
            if (validDataWithIndices.length > 0) batchResults = await this.writeProvider.writeDataBatch(validDataWithIndices);
            return [
                ...batchResults,
                ...invalidResults
            ];
        }
        // Fall back to individual writes
        const results = await Promise.allSettled(nodes.map((_node, index)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            if (!data[index].content) return Promise.reject('No Synced Block content to write');
            return this.writeProvider?.writeData(data[index]);
        }));
        return results.map((result)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                error: result.reason
            };
        });
    }
    createNodeData(data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        return this.writeProvider.createData(data).then((result)=>result, (error)=>({
                error: error
            }));
    }
    /**
   * Delete the data from the write provider
   *
   * @param resourceIds
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async deleteNodesData(resourceIds, deletionReason) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        const results = await Promise.allSettled(resourceIds.map((resourceId)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            return this.writeProvider.deleteData(resourceId, deletionReason);
        }));
        return results.map((result, index)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                resourceId: resourceIds[index],
                success: false,
                error: result.reason
            };
        });
    }
    /**
   * Fetch the source info from the source id
   *
   * @param params
   * @param params.sourceAri - The source ARI
   * @param params.sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The source info
   */ async fetchSyncBlockSourceInfo(localId, sourceAri, sourceProduct, hasAccess = true) {
        const ari = sourceAri ?? this.writeProvider?.parentAri;
        const product = sourceProduct ?? (0, $3xsB6.getProductFromSourceAri)(ari);
        if (!ari || !product) return Promise.reject(new Error('Source ari or source product is undefined'));
        switch(product){
            case 'confluence-page':
                {
                    const sourceInfo = await (0, $fRKL0.fetchConfluencePageInfo)(ari, hasAccess, localId);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            case 'jira-work-item':
                {
                    // Note: `subType`, archived URL handling, and `isUnpublished` are intentionally
                    // omitted here — Jira work items have no equivalent page subtype or archived state.
                    // The `localId` param is intentionally not forwarded: the current Jira issue view
                    // does not scroll to `#block-{localId}` anchors, so passing it would only pollute
                    // the URL. See the parity-notes JSDoc on `fetchJiraWorkItemInfo` for the full
                    // rationale and the conditions under which this should be revisited.
                    const sourceInfo = await (0, $83vgd.fetchJiraWorkItemInfo)(ari, hasAccess);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            default:
                return Promise.reject(new Error(`${product} source product not supported`));
        }
    }
    generateResourceId() {
        const localId = crypto.randomUUID();
        const resourceId = crypto.randomUUID();
        return {
            localId: localId,
            resourceId: resourceId
        };
    }
    generateResourceIdForReference(sourceId) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.generateResourceIdForReference(sourceId);
    }
    /**
   * Get the synced block renderer provider options
   *
   * @returns The synced block renderer provider options
   */ getSyncedBlockRendererProviderOptions() {
        return this.providerOptions;
    }
    /**
   * Retrieve the parent info for the sync block
   *
   * @param sourceAri - The source ARI
   * @param sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The parent info for the sync block
   */ retrieveSyncBlockParentInfo(sourceAri, sourceProduct) {
        if (!sourceAri || !sourceProduct) return undefined;
        switch(sourceProduct){
            case 'confluence-page':
                return {
                    contentAri: sourceAri,
                    contentId: (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
                        ari: sourceAri
                    }).id,
                    contentProduct: sourceProduct
                };
            case 'jira-work-item':
                return {
                    contentAri: sourceAri,
                    contentId: sourceAri,
                    contentProduct: sourceProduct
                };
            default:
                throw new Error(`${sourceProduct} source product not supported`);
        }
    }
    updateReferenceData(blocks, noContent) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.updateReferenceData(blocks, noContent);
    }
    fetchReferences(resourceId, isSource) {
        if (!this.fetchProvider) throw new Error('Fetch provider not set');
        return this.fetchProvider.fetchReferences(isSource ? this.generateResourceIdForReference(resourceId) : resourceId);
    }
    /**
   * Subscribes to real-time updates for a specific block.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates, or undefined if not supported
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        if (this.fetchProvider.subscribeToBlockUpdates) return this.fetchProvider.subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete);
        return undefined;
    }
    /**
   * Constructor for the SyncedBlockProvider
   *
   * @param fetchProvider
   * @param writeProvider
   * @param nestedRendererDataProviders
   */ constructor(fetchProvider, writeProvider){
        super();
        this.name = 'syncBlockProvider';
        this.fetchProvider = void 0;
        this.writeProvider = void 0;
        this.providerOptions = void 0;
        this.fetchProvider = fetchProvider;
        this.writeProvider = writeProvider;
        this.providerOptions = {};
    }
}
const $0b95be1fc334e182$var$createSyncedBlockProvider = ({ fetchProvider: fetchProvider, writeProvider: writeProvider })=>{
    return new $0b95be1fc334e182$export$ead9a287a0b743c7(fetchProvider, writeProvider);
};
const $0b95be1fc334e182$export$ae97d432056ca005 = ({ fetchProvider: fetchProvider, writeProvider: writeProvider, providerOptions: providerOptions, getSSRData: getSSRData })=>{
    const syncBlockProvider = (0, $cozmU.useMemo)(()=>$0b95be1fc334e182$var$createSyncedBlockProvider({
            fetchProvider: fetchProvider,
            writeProvider: writeProvider
        }), [
        fetchProvider,
        writeProvider
    ]);
    const prevProviderOptionsRef = (0, $cozmU.useRef)(undefined);
    if (providerOptions !== prevProviderOptionsRef.current) {
        prevProviderOptionsRef.current = providerOptions;
        syncBlockProvider.setProviderOptions(providerOptions);
    }
    const prevSSRDataRef = (0, $cozmU.useRef)(undefined);
    const ssrData = getSSRData?.();
    if (ssrData !== prevSSRDataRef.current) {
        prevSSRDataRef.current = ssrData;
        if (ssrData) syncBlockProvider.setSSRData(ssrData);
    }
    return syncBlockProvider;
};
module.exports["useMemoizedSyncedBlockProvider"] = $0b95be1fc334e182$export$ae97d432056ca005;

});

parcelRegister("fRKL0", function(module, exports) {

var $48FpT = parcelRequire("48FpT");

const $b7038d533618bb27$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $b7038d533618bb27$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $b7038d533618bb27$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the page subtype by id (i.e. live or classic)
 * @param documentARI
 * @returns subType live if livePage, subType null if classic page
 */ const $b7038d533618bb27$var$GET_SOURCE_INFO_QUERY = `query ${$b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!, $status: [String]) {
	content (id: $id, status: $status) {
		nodes {
			id
			links {
				base
				editui
				webui
			}
			space {
				key
			}
			status
			subType
			title
		}
	}
}`;
const $b7038d533618bb27$var$getConfluenceSourceInfo = async (ari, status)=>{
    const variables = {
        id: ari
    };
    if (status) variables.status = status;
    const bodyData = {
        query: $b7038d533618bb27$var$GET_SOURCE_INFO_QUERY,
        operationName: $b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: variables
    };
    const response = await (0, $48FpT.fetchWithRetry)($b7038d533618bb27$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$b7038d533618bb27$var$COMMON_HEADERS,
            ...$b7038d533618bb27$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $b7038d533618bb27$var$resolveNoAccessPageInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $b7038d533618bb27$export$11ee05f70c94d3d7 = async (pageAri, hasAccess, localId)=>{
    if (hasAccess) {
        const status = [
            'draft',
            'archived',
            'current'
        ];
        const response = await $b7038d533618bb27$var$getConfluenceSourceInfo(pageAri, status);
        const contentData = response.data?.content?.nodes?.[0];
        const { title: title, subType: subType } = contentData || {};
        let url;
        const { base: base, editui: editui, webui: webui } = contentData?.links || {};
        const pageStatus = contentData?.status;
        if (base && editui && pageStatus !== 'archived') url = `${base}${editui}`;
        else if (base && webui && pageStatus === 'archived') url = `${base}${webui}`;
        url = url && localId ? `${url}#block-${localId}` : url;
        return Promise.resolve({
            title: title,
            url: url,
            sourceAri: pageAri,
            subType: subType
        });
    } else return await $b7038d533618bb27$var$resolveNoAccessPageInfo(pageAri);
};
module.exports["fetchConfluencePageInfo"] = $b7038d533618bb27$export$11ee05f70c94d3d7;

});

parcelRegister("83vgd", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $48FpT = parcelRequire("48FpT");


var $EBNuL = parcelRequire("EBNuL");

const $a860b21f53e6eb68$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $a860b21f53e6eb68$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $a860b21f53e6eb68$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the work item url by id
 * @param id - the ID of the work item
 * @returns url of the work item
 */ // `issueType` is requested alongside `summary` and `webUrl` so the
// SyncedLocationDropdown can render the correct ADS issue-type icon.
const $a860b21f53e6eb68$var$GET_SOURCE_INFO_QUERY = `query ${$a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!) {
  jira {
	issueById(id: $id) {
	id
	webUrl
	summary
	issueType {
		name
		avatar {
		xsmall
		}
	}
	}
  }}`;
const $a860b21f53e6eb68$var$getJiraWorkItemSourceInfo = async (issueAri)=>{
    const bodyData = {
        query: $a860b21f53e6eb68$var$GET_SOURCE_INFO_QUERY,
        operationName: $a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: {
            id: issueAri
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($a860b21f53e6eb68$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$a860b21f53e6eb68$var$COMMON_HEADERS,
            ...$a860b21f53e6eb68$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $a860b21f53e6eb68$var$resolveNoAccessWorkItemInfo = async (sourceAri, issueAri)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: issueAri
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: sourceAri
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $a860b21f53e6eb68$export$5e43429d194de44c = async (workItemAri, hasAccess)=>{
    // AGG `issueById` and object-resolver only understand issue ARIs. Field-value
    // source ARIs keep their original identity on the returned `sourceAri`.
    const issueAri = (0, $EBNuL.getJiraIssueAriFromSourceAri)({
        ari: workItemAri
    });
    if (hasAccess) {
        const response = await $a860b21f53e6eb68$var$getJiraWorkItemSourceInfo(issueAri);
        const contentData = response.data?.jira?.issueById;
        const webUrl = typeof contentData?.webUrl === 'string' ? contentData.webUrl : undefined;
        const summary = typeof contentData?.summary === 'string' ? contentData.summary : undefined;
        // Surface issue-type metadata for the SyncedLocationDropdown's ADS icon.
        // Defensive narrowing: only surface when `name` is a non-empty string;
        // AGG values like `{ name: null }` collapse back to `undefined`.
        const issueTypeName = contentData?.issueType?.name;
        const issueType = typeof issueTypeName === 'string' && issueTypeName.length > 0 ? {
            name: issueTypeName,
            iconUrl: typeof contentData?.issueType?.avatar?.xsmall === 'string' ? contentData.issueType.avatar.xsmall : undefined
        } : undefined;
        return Promise.resolve({
            url: webUrl,
            sourceAri: workItemAri,
            title: summary,
            issueType: issueType
        });
    } else return await $a860b21f53e6eb68$var$resolveNoAccessWorkItemInfo(workItemAri, issueAri);
};
module.exports["fetchJiraWorkItemInfo"] = $a860b21f53e6eb68$export$5e43429d194de44c;

});

parcelRegister("PkUFx", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

class $25a65744798df56f$export$cd52318aefe371fb extends (0, $drRzc.NodeDataProvider) {
}
module.exports["SyncBlockDataProviderInterface"] = $25a65744798df56f$export$cd52318aefe371fb;

});

parcelRegister("imQxZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $h75sz = parcelRequire("h75sz");


var $i2lVL = parcelRequire("i2lVL");


var $d04Ge = parcelRequire("d04Ge");

var $5I78X = parcelRequire("5I78X");


var $f0Xuo = parcelRequire("f0Xuo");

const $d1eca226e08e8008$export$28a555a4d57f5843 = (doc)=>{
    const { content: content } = doc;
    const isEmpty = !content || !Array.isArray(content) || content.length === 0;
    const syncBlockNodes = isEmpty ? [] : content.map((node)=>(0, $d04Ge.convertSyncBlockJSONNodeToSyncBlockNode)(node)).filter((node)=>node !== undefined);
    return syncBlockNodes;
};
const $d1eca226e08e8008$export$2813820533ed0641 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getAccountId: getAccountId, getPrefetchedData: getPrefetchedData, enableRealTimeSubscriptions: enableRealTimeSubscriptions } = t0;
    let t1;
    if ($[0] !== enableRealTimeSubscriptions) {
        t1 = {
            enableRealTimeSubscriptions: enableRealTimeSubscriptions
        };
        $[0] = enableRealTimeSubscriptions;
        $[1] = t1;
    } else t1 = $[1];
    const syncBlockStoreManager = (0, $5I78X.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent, t1);
    let t2;
    let t3;
    if ($[2] !== getPrefetchedData || $[3] !== syncBlockStoreManager.referenceManager) {
        t2 = ()=>{
            if (getPrefetchedData) try {
                const prefetchedData = getPrefetchedData();
                syncBlockStoreManager.referenceManager.processPrefetchedData(prefetchedData);
            } catch  {}
        };
        t3 = [
            getPrefetchedData,
            syncBlockStoreManager.referenceManager
        ];
        $[2] = getPrefetchedData;
        $[3] = syncBlockStoreManager.referenceManager;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== syncBlockNodes || $[7] !== syncBlockStoreManager.referenceManager) {
        t4 = ()=>{
            if (!(syncBlockStoreManager.referenceManager.hasDataProvider?.() ?? false)) return;
            syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
        };
        t5 = [
            syncBlockNodes,
            syncBlockStoreManager.referenceManager
        ];
        $[6] = syncBlockNodes;
        $[7] = syncBlockStoreManager.referenceManager;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[10] !== fireAnalyticsEvent || $[11] !== getAccountId || $[12] !== syncBlockRendererOptions || $[13] !== syncBlockStoreManager) {
        t6 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                dispatchAnalyticsEvent: fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i2lVL.SyncBlockActionsProvider), {
                    fetchSyncBlockSourceInfo: (sourceAri)=>syncBlockStoreManager.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f0Xuo.SyncedBlockNodeComponentRenderer), {
                        nodeProps: props,
                        syncBlockStoreManager: syncBlockStoreManager,
                        rendererOptions: syncBlockRendererOptions,
                        getAccountId: getAccountId
                    }, props.localId)
                })
            });
        $[10] = fireAnalyticsEvent;
        $[11] = getAccountId;
        $[12] = syncBlockRendererOptions;
        $[13] = syncBlockStoreManager;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getAccountId: getAccountId, getPrefetchedData: getPrefetchedData, enableRealTimeSubscriptions: enableRealTimeSubscriptions })=>{
    const syncBlockStoreManager = (0, $5I78X.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent, {
        enableRealTimeSubscriptions: enableRealTimeSubscriptions
    });
    // Process prefetched data early, if available
    (0, $cozmU.useEffect)(()=>{
        if (getPrefetchedData) try {
            const prefetchedData = getPrefetchedData();
            syncBlockStoreManager.referenceManager.processPrefetchedData(prefetchedData);
        } catch  {
        // Silently ignore errors from getPrefetchedData so the fetch effect can still run
        }
    }, [
        getPrefetchedData,
        syncBlockStoreManager.referenceManager
    ]);
    // Initial fetch sync block data (will use SSR data as initial cache, or the prefetched data if available)
    (0, $cozmU.useEffect)(()=>{
        // On Jira the data provider resolves asynchronously (and is nulled on
        // `destroy()`), so an eager fetch can throw `Data provider not set`
        // (EDITOR-7860). Skip until ready; the effect re-runs (referenceManager
        // identity changes) once the provider resolves, fetching exactly once.
        if (!(syncBlockStoreManager.referenceManager.hasDataProvider?.() ?? false)) return;
        syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
    }, [
        syncBlockNodes,
        syncBlockStoreManager.referenceManager
    ]);
    return (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
            component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            dispatchAnalyticsEvent: fireAnalyticsEvent,
            fallbackComponent: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i2lVL.SyncBlockActionsProvider), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                fetchSyncBlockSourceInfo: (sourceAri)=>syncBlockStoreManager.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f0Xuo.SyncedBlockNodeComponentRenderer), {
                    nodeProps: props,
                    syncBlockStoreManager: syncBlockStoreManager,
                    rendererOptions: syncBlockRendererOptions,
                    getAccountId: getAccountId
                }, props.localId)
            })
        }), [
        syncBlockStoreManager,
        syncBlockRendererOptions,
        fireAnalyticsEvent,
        getAccountId
    ]);
};
module.exports["getSyncBlockNodesFromDoc"] = $d1eca226e08e8008$export$28a555a4d57f5843;
module.exports["useMemoizedSyncedBlockNodeComponent"] = $d1eca226e08e8008$export$2813820533ed0641;

});

parcelRegister("f0Xuo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $amQv1 = parcelRequire("amQv1");

var $95bQO = parcelRequire("95bQO");


var $79ir6 = parcelRequire("79ir6");

var $4cJIQ = parcelRequire("4cJIQ");


var $3txmH = parcelRequire("3txmH");

const $31229fe543feeb5b$export$da661eaac6059c75 = ({ nodeProps: nodeProps, syncBlockStoreManager: syncBlockStoreManager, rendererOptions: rendererOptions, getAccountId: getAccountId })=>{
    const { resourceId: resourceId, localId: localId, fireAnalyticsEvent: fireAnalyticsEvent } = nodeProps;
    // `fireAnalyticsEvent` from NodeProps is typed as the generic
    // `AnalyticsEventPayload`. The synced-block consumers below
    // (`updateFireAnalyticsEvent`, `useFetchSyncBlockData`, `renderSyncedBlockContent`)
    // only ever invoke it with the narrower `RendererSyncBlockEventPayload`
    // union, which is a strict subset of `AnalyticsEventPayload`, so the cast
    // is safe.
    const syncBlockFireAnalyticsEvent = fireAnalyticsEvent;
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            // handleSSRErrorsAnalytics expects only `SyncedBlockSSRErrorAEP` — the
            // generic `fireAnalyticsEvent` from NodeProps is a superset, so the
            // cast is safe (the handler only ever calls back with that one AEP).
            (0, $amQv1.handleSSRErrorsAnalytics)(fireAnalyticsEvent);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        syncBlockStoreManager.referenceManager.updateFireAnalyticsEvent(syncBlockFireAnalyticsEvent);
    }, [
        syncBlockStoreManager.referenceManager,
        syncBlockFireAnalyticsEvent
    ]);
    const { syncBlockInstance: syncBlockInstance, isLoading: isLoading, reloadData: reloadData, providerFactory: providerFactory, ssrProviders: ssrProviders } = (0, $4cJIQ.useFetchSyncBlockData)(syncBlockStoreManager, resourceId, localId, syncBlockFireAnalyticsEvent);
    const finalRendererOptions = (0, $cozmU.useMemo)(()=>{
        if (rendererOptions?.media?.ssr || // already has ssr config
        !ssrProviders?.media?.viewMediaClientConfig) return rendererOptions;
        const mediaSSR = {
            // Use synced block's media config so auth uses source contentId, not current page.
            // Server: during SSR; client: after hydration (avoids using page's MediaClient).
            mode: (0, $4iudd.isSSR)() ? 'server' : 'client',
            config: ssrProviders?.media.viewMediaClientConfig
        };
        return {
            ...rendererOptions,
            media: {
                ...rendererOptions?.media || {},
                ssr: mediaSSR
            }
        };
    }, [
        rendererOptions,
        ssrProviders
    ]);
    const errorForDisplay = syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
        type: (0, $79ir6.SyncBlockError).NotFound,
        reason: syncBlockInstance.data?.deletionReason
    } : {
        type: (0, $79ir6.SyncBlockError).Errored,
        // Keep `reason` static — the block's `resourceId` is emitted as its own
        // analytics attribute, so interpolating it here would only leak the
        // identifier into the `error` string.
        reason: !resourceId ? 'missing resource id' : 'missing data'
    });
    const result = (0, $3txmH.renderSyncedBlockContent)({
        syncBlockInstance: syncBlockInstance ?? undefined,
        isLoading: isLoading,
        rendererOptions: finalRendererOptions,
        providerFactory: providerFactory,
        reloadData: reloadData,
        fireAnalyticsEvent: syncBlockFireAnalyticsEvent,
        resourceId: resourceId,
        error: errorForDisplay,
        getAccountId: getAccountId,
        // Prefix heading ids with the reference node's localId so ToC deep links
        // and heading anchor links resolve, and so the same source block embedded
        // twice on a page produces distinct, stable ids. Only takes effect when the
        // renderer options enable heading anchor links; otherwise the prefix is set
        // but ids stay disabled inside AKRendererWrapper.
        headingIdPrefix: localId
    });
    if (result.isSuccess) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $95bQO.SyncBlockSharedCssClassName).renderer,
        [(0, $95bQO.SyncBlockRendererDataAttributeName)]: true,
        children: result.element
    });
    return result.element;
};
module.exports["SyncedBlockNodeComponentRenderer"] = $31229fe543feeb5b$export$da661eaac6059c75;

});

parcelRegister("amQv1", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $gb05o = parcelRequire("gb05o");

const $59f6e19db6d712cc$var$isSyncedBlocksSSRErrorObj = (maybeSSRErrorObj)=>{
    if (!maybeSSRErrorObj || typeof maybeSSRErrorObj !== 'object') return false;
    const errorWrapper = maybeSSRErrorObj;
    // Check for meta object with valid code
    const hasValidMeta = errorWrapper.meta && typeof errorWrapper.meta === 'object' && Object.values((0, $gb05o.SyncedBlocksSSRErrorCodeMap)).includes(errorWrapper.meta.code);
    return Boolean(hasValidMeta);
};
/**
 * Get the first SSR error for synced blocks from the window.__SSR_ERROR__ array.
 *
 * Expected structure of error objects stored in confluence window.__SSR_ERROR__ for synced blocks SSR errors:
 *
 * @example
 * {
 *   error: {
 *     message: "Synced blocks fetch operation timed out",
 *     stack: "Error: Synced blocks fetch operation timed out\n    at /tmp/script.js:xxx:xxx"
 *   },
 *   meta: {
 *     code: "SYNCED_BLOCKS_FETCH_TIMEOUT",
 *     contentId: "XXXXXX",
 *     cloudId: "XXXX-XXXX-XXXX-XXXX-XXXX",
 *     isBlog: false,
 *     identifiers: [
 *       {
 *         resourceId: "confluence-page/XXXXXX/XXXX-XXXX-XXXX-XXXX-XXXX",
 *         blockInstanceId: "XXXX-XXXX-XXXX-XXXX-XXXX"
 *       }
 *     ]
 *   }
 * }
 *
 * @returns The first SSR error metadata, or undefined if no error found
 */ const $59f6e19db6d712cc$var$getSyncedBlocksSSRError = ()=>{
    if ((0, $4iudd.isSSR)()) return undefined;
    const ssrErrors = window.__SSR_ERROR__;
    if (Array.isArray(ssrErrors)) {
        const syncedBlockErrors = ssrErrors.filter($59f6e19db6d712cc$var$isSyncedBlocksSSRErrorObj).map((errorWrapper)=>errorWrapper.meta);
        return syncedBlockErrors.length > 0 ? syncedBlockErrors[0] : undefined;
    }
    return undefined;
};
const $59f6e19db6d712cc$export$8be916857642095b = (()=>{
    let called = false;
    // I want this fireAnalyticsEvent only takes in SyncedBlockSSRErrorAEP
    return (fireAnalyticsEvent)=>{
        if (called) return;
        called = true;
        if (!fireAnalyticsEvent) return;
        const error = $59f6e19db6d712cc$var$getSyncedBlocksSSRError();
        if (error) fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SSR_ERROR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                code: error.code,
                isBlog: error.isBlog,
                syncedBlocksCount: error.identifiers?.length || 0,
                missingSyncedBlocksCount: error.missingIdentifiers?.length || 0,
                errorMessage: error.errorMessage,
                errorName: error.errorName
            }
        });
    };
})();
module.exports["handleSSRErrorsAnalytics"] = $59f6e19db6d712cc$export$8be916857642095b;

});

parcelRegister("3txmH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $79ir6 = parcelRequire("79ir6");


var $4o0zT = parcelRequire("4o0zT");


var $3OdcW = parcelRequire("3OdcW");


var $7lQV1 = parcelRequire("7lQV1");


var $4Hfg5 = parcelRequire("4Hfg5");

function $753b4334064f552c$export$6942d731e9271481({ syncBlockInstance: syncBlockInstance, isLoading: isLoading, rendererOptions: rendererOptions, providerFactory: providerFactory, reloadData: reloadData, fireAnalyticsEvent: fireAnalyticsEvent, resourceId: resourceId, isOffline: isOffline, error: error, getAccountId: getAccountId, headingIdPrefix: headingIdPrefix }) {
    const isSSRMode = (0, $4iudd.isSSR)();
    if (isOffline && !isSSRMode) return {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7lQV1.SyncedBlockErrorComponent), {
            error: {
                type: (0, $79ir6.SyncBlockError).Offline
            }
        }),
        isSuccess: false
    };
    if (isLoading && !syncBlockInstance) return {
        element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Hfg5.SyncedBlockLoadingState), {}),
        isSuccess: false
    };
    if (isSSRMode && syncBlockInstance?.error) return {
        element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Hfg5.SyncedBlockLoadingState), {}),
        isSuccess: false
    };
    if (!resourceId || syncBlockInstance?.error || !syncBlockInstance?.data || syncBlockInstance.data.status === 'deleted') {
        const errorToDisplay = error ?? syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
            type: (0, $79ir6.SyncBlockError).NotFound
        } : {
            type: (0, $79ir6.SyncBlockError).Errored
        });
        return {
            element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7lQV1.SyncedBlockErrorComponent), {
                error: errorToDisplay,
                resourceId: resourceId,
                onRetry: reloadData,
                isLoading: isLoading,
                fireAnalyticsEvent: fireAnalyticsEvent,
                getAccountId: getAccountId
            }),
            isSuccess: false
        };
    }
    const isLocalSameDocumentSource = Boolean(syncBlockInstance.localSameDocumentSource) && (0, $4o0zT.isExperimentEnabled)('editor-synced-block-same-page-sync');
    if (syncBlockInstance.data.status === 'unpublished' && !isLocalSameDocumentSource) return {
        element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7lQV1.SyncedBlockErrorComponent), {
            /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ error: {
                type: (0, $79ir6.SyncBlockError).Unpublished
            },
            resourceId: resourceId,
            sourceURL: syncBlockInstance.data?.sourceURL,
            fireAnalyticsEvent: fireAnalyticsEvent,
            getAccountId: getAccountId
        }),
        isSuccess: false
    };
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return {
        element: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3OdcW.AKRendererWrapper), {
            doc: syncBlockDoc,
            dataProviders: providerFactory,
            options: rendererOptions,
            headingIdPrefix: headingIdPrefix
        }),
        isSuccess: true
    };
}
module.exports["renderSyncedBlockContent"] = $753b4334064f552c$export$6942d731e9271481;

});

parcelRegister("3OdcW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $4o0zT = parcelRequire("4o0zT");


var $6lXol = parcelRequire("6lXol");

var $3BY7M = parcelRequire("3BY7M");

var $8Kasn = parcelRequire("8Kasn");


var $hRnS5 = parcelRequire("hRnS5");


var $kS1Yv = parcelRequire("kS1Yv");


var $lpNn5 = parcelRequire("lpNn5");

const $8039e8ec23b90f97$var$ValidationContextWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            allowNestedTables: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const validationContextValue = t1;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8Kasn.ValidationContextProvider), {
            value: validationContextValue,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    const validationContextValue = (0, $cozmU.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8Kasn.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $8039e8ec23b90f97$var$DisabledTaskWithTooltip = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let componentKey;
    let props;
    if ($[0] !== t0) {
        ({ componentKey: componentKey, ...props } = t0);
        $[0] = t0;
        $[1] = componentKey;
        $[2] = props;
    } else {
        componentKey = $[1];
        props = $[2];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[3] !== formatMessage) {
        t1 = formatMessage((0, $aI2Eh.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
        $[3] = formatMessage;
        $[4] = t1;
    } else t1 = $[4];
    const tooltipContent = t1;
    const Component = (0, $6lXol.nodeToReact)[componentKey];
    let t2;
    if ($[5] !== Component || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            ...props,
            disableOnChange: true
        });
        $[5] = Component;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t2 || $[9] !== tooltipContent) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            position: "auto-start",
            children: t2
        });
        $[8] = t2;
        $[9] = tooltipContent;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ componentKey: componentKey, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = formatMessage((0, $aI2Eh.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
    const Component = (0, $6lXol.nodeToReact)[componentKey];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        position: "auto-start",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            ...props,
            disableOnChange: true
        })
    });
};
const $8039e8ec23b90f97$var$defaultOptions = {
    appearance: 'full-width',
    allowAltTextOnImages: true,
    allowAnnotations: true,
    allowColumnSorting: true,
    allowCopyToClipboard: true,
    allowCustomPanels: true,
    allowPlaceholderText: true,
    allowRendererContainerStyles: true,
    allowSelectAllTrap: true,
    allowUgcScrubber: true,
    allowWrapCodeBlock: true,
    emojiResourceConfig: undefined,
    media: {
        allowLinking: true,
        allowCaptions: true,
        featureFlags: {
            mediaInline: true
        }
    },
    smartLinks: {
        ssr: true
    }
};
const $8039e8ec23b90f97$export$cc2ec5e10e7ca244 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { doc: doc, dataProviders: dataProviders, options: options, headingIdPrefix: headingIdPrefix } = t0;
    let t1;
    if ($[0] !== options) {
        const mergedOptions = {
            ...$8039e8ec23b90f97$var$defaultOptions,
            ...options
        };
        t1 = mergedOptions ?? {};
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, eventHandlers: eventHandlers, media: media, mentionNodeDataProvider: mentionNodeDataProvider, smartLinks: smartLinks, stickyHeaders: stickyHeaders, contentMode: contentMode } = t1;
    const headingIdsEnabled = typeof headingIdPrefix === "string" && headingIdPrefix.length > 0 && Boolean(allowHeadingAnchorLinks);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            taskItem: $8039e8ec23b90f97$var$_temp,
            blockTaskItem: $8039e8ec23b90f97$var$_temp2
        };
        $[2] = t2;
    } else t2 = $[2];
    const nodeComponents = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            nestedRendererType: "syncedBlock"
        };
        $[3] = t3;
    } else t3 = $[3];
    const t4 = !headingIdsEnabled;
    const t5 = headingIdsEnabled ? headingIdPrefix : undefined;
    let t6;
    if ($[4] !== mentionNodeDataProvider) {
        t6 = (0, $4o0zT.isExperimentEnabled)("platform_editor_mention_avatar_synced_block") ? mentionNodeDataProvider : undefined;
        $[4] = mentionNodeDataProvider;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== allowAltTextOnImages || $[7] !== allowAnnotations || $[8] !== allowColumnSorting || $[9] !== allowCopyToClipboard || $[10] !== allowCustomPanels || $[11] !== allowHeadingAnchorLinks || $[12] !== allowPlaceholderText || $[13] !== allowRendererContainerStyles || $[14] !== allowSelectAllTrap || $[15] !== allowUgcScrubber || $[16] !== allowWrapCodeBlock || $[17] !== appearance || $[18] !== contentMode || $[19] !== dataProviders || $[20] !== doc || $[21] !== emojiResourceConfig || $[22] !== eventHandlers || $[23] !== media || $[24] !== smartLinks || $[25] !== stickyHeaders || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hRnS5.RendererActionsContext), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kS1Yv.RendererContextProvider), {
                    value: t3,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        "data-testid": "sync-block-renderer-wrapper",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3BY7M.default), {
                            appearance: appearance,
                            adfStage: "stage0",
                            document: doc,
                            disableHeadingIDs: t4,
                            headingIdPrefix: t5,
                            dataProviders: dataProviders,
                            nodeComponents: nodeComponents,
                            allowAltTextOnImages: allowAltTextOnImages,
                            allowAnnotations: allowAnnotations,
                            allowColumnSorting: allowColumnSorting,
                            allowCopyToClipboard: allowCopyToClipboard,
                            allowCustomPanels: allowCustomPanels,
                            allowHeadingAnchorLinks: allowHeadingAnchorLinks,
                            allowPlaceholderText: allowPlaceholderText,
                            allowRendererContainerStyles: allowRendererContainerStyles,
                            allowSelectAllTrap: allowSelectAllTrap,
                            allowUgcScrubber: allowUgcScrubber,
                            allowWrapCodeBlock: allowWrapCodeBlock,
                            disableTableOverflowShadow: true,
                            emojiResourceConfig: emojiResourceConfig,
                            eventHandlers: eventHandlers,
                            media: media,
                            mentionNodeDataProvider: t6,
                            smartLinks: smartLinks,
                            stickyHeaders: stickyHeaders,
                            contentMode: contentMode
                        })
                    })
                })
            })
        });
        $[6] = allowAltTextOnImages;
        $[7] = allowAnnotations;
        $[8] = allowColumnSorting;
        $[9] = allowCopyToClipboard;
        $[10] = allowCustomPanels;
        $[11] = allowHeadingAnchorLinks;
        $[12] = allowPlaceholderText;
        $[13] = allowRendererContainerStyles;
        $[14] = allowSelectAllTrap;
        $[15] = allowUgcScrubber;
        $[16] = allowWrapCodeBlock;
        $[17] = appearance;
        $[18] = contentMode;
        $[19] = dataProviders;
        $[20] = doc;
        $[21] = emojiResourceConfig;
        $[22] = eventHandlers;
        $[23] = media;
        $[24] = smartLinks;
        $[25] = stickyHeaders;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
    } else t7 = $[29];
    return t7;
} : ({ doc: doc, dataProviders: dataProviders, options: options, headingIdPrefix: headingIdPrefix })=>{
    const mergedOptions = {
        ...$8039e8ec23b90f97$var$defaultOptions,
        ...options
    };
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, eventHandlers: eventHandlers, media: media, mentionNodeDataProvider: mentionNodeDataProvider, smartLinks: smartLinks, stickyHeaders: stickyHeaders, contentMode: contentMode } = mergedOptions ?? {};
    // Only stamp heading ids when a prefix is supplied AND the consumer has
    // opted into heading anchor links. This keeps the change scoped: consumers
    // that enable ToC/anchor support (e.g. Confluence, behind its experiment)
    // pass both a per-instance prefix (the reference block's localId) and
    // `allowHeadingAnchorLinks`; every other consumer keeps id-less headings and
    // is unaffected.
    const headingIdsEnabled = typeof headingIdPrefix === 'string' && headingIdPrefix.length > 0 && Boolean(allowHeadingAnchorLinks);
    const nodeComponents = (0, $cozmU.useMemo)(()=>{
        return {
            taskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
                    componentKey: "taskItem",
                    ...props
                });
            },
            blockTaskItem: (props_0)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
                    componentKey: "blockTaskItem",
                    ...props_0
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hRnS5.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$ValidationContextWrapper, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kS1Yv.RendererContextProvider), {
                value: {
                    nestedRendererType: 'syncedBlock'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    "data-testid": "sync-block-renderer-wrapper",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3BY7M.default), {
                        appearance: appearance,
                        adfStage: "stage0",
                        document: doc,
                        disableHeadingIDs: !headingIdsEnabled,
                        headingIdPrefix: headingIdsEnabled ? headingIdPrefix : undefined,
                        dataProviders: dataProviders,
                        nodeComponents: nodeComponents,
                        allowAltTextOnImages: allowAltTextOnImages,
                        allowAnnotations: allowAnnotations,
                        allowColumnSorting: allowColumnSorting,
                        allowCopyToClipboard: allowCopyToClipboard,
                        allowCustomPanels: allowCustomPanels,
                        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
                        allowPlaceholderText: allowPlaceholderText,
                        allowRendererContainerStyles: allowRendererContainerStyles,
                        allowSelectAllTrap: allowSelectAllTrap,
                        allowUgcScrubber: allowUgcScrubber,
                        allowWrapCodeBlock: allowWrapCodeBlock,
                        disableTableOverflowShadow: true,
                        emojiResourceConfig: emojiResourceConfig,
                        eventHandlers: eventHandlers,
                        media: media,
                        // Synced block replica locations render through this wrapper rather than the
                        // main editor/renderer surfaces, so forwarding the provider here is gated
                        // independently of `platform_editor_mention_node_avatar` (which still controls
                        // whether the avatar itself renders once a provider is present).
                        mentionNodeDataProvider: (0, $4o0zT.isExperimentEnabled)('platform_editor_mention_avatar_synced_block') ? mentionNodeDataProvider : undefined,
                        smartLinks: smartLinks,
                        stickyHeaders: stickyHeaders,
                        contentMode: contentMode
                    })
                })
            })
        })
    });
});
function $8039e8ec23b90f97$var$_temp(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
        componentKey: "taskItem",
        ...props
    });
}
function $8039e8ec23b90f97$var$_temp2(props_0) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
        componentKey: "blockTaskItem",
        ...props_0
    });
}
module.exports["AKRendererWrapper"] = $8039e8ec23b90f97$export$cc2ec5e10e7ca244;

});

parcelRegister("7lQV1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jv11C = parcelRequire("jv11C");


var $95bQO = parcelRequire("95bQO");


var $916Gd = parcelRequire("916Gd");

var $d04Ge = parcelRequire("d04Ge");

var $79ir6 = parcelRequire("79ir6");








var $8bpSu = parcelRequire("8bpSu");


var $cV42A = parcelRequire("cV42A");


var $6b2ZK = parcelRequire("6b2ZK");


var $1TrZ6 = parcelRequire("1TrZ6");


var $1zvH6 = parcelRequire("1zvH6");


var $evEE0 = parcelRequire("evEE0");


var $4NWzb = parcelRequire("4NWzb");

const $2a4f71ad51426bfa$var$getForbiddenErrorContent = (resourceId, fireAnalyticsEvent, getAccountId)=>{
    try {
        if (!resourceId) throw new Error('Missing resource id');
        const { sourceContentId: sourceContentId, sourceProduct: sourceProduct } = (0, $d04Ge.getContentIdAndProductFromResourceId)(resourceId);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $evEE0.SyncedBlockPermissionDenied), {
            sourceContentId: sourceContentId,
            sourceProduct: sourceProduct,
            accountId: getAccountId?.() ?? null
        });
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-renderer/SyncedBlockErrorComponent'
        });
        fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message));
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cV42A.SyncedBlockGenericError), {});
    }
};
const $2a4f71ad51426bfa$export$f4d17ad2341a04f8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent, sourceURL: sourceURL, getAccountId: getAccountId } = t0;
    let t1;
    if ($[0] !== error?.originalMessage || $[1] !== error?.reason || $[2] !== error?.statusCode || $[3] !== error?.type || $[4] !== fireAnalyticsEvent || $[5] !== resourceId) {
        t1 = ()=>{
            const rawError = error?.originalMessage || error?.reason || error?.type || "unknown";
            fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(`${rawError}: error component rendered`, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(rawError, error?.statusCode)));
        };
        $[0] = error?.originalMessage;
        $[1] = error?.reason;
        $[2] = error?.statusCode;
        $[3] = error?.type;
        $[4] = fireAnalyticsEvent;
        $[5] = resourceId;
        $[6] = t1;
    } else t1 = $[6];
    const t2 = error?.originalMessage;
    const t3 = error?.reason;
    const t4 = error?.type;
    const t5 = error?.statusCode;
    let t6;
    if ($[7] !== fireAnalyticsEvent || $[8] !== resourceId || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
        t6 = [
            t2,
            t3,
            t4,
            t5,
            resourceId,
            fireAnalyticsEvent
        ];
        $[7] = fireAnalyticsEvent;
        $[8] = resourceId;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    (0, $cozmU.useEffect)(t1, t6);
    let t7;
    bb0: switch(error?.type){
        case (0, $79ir6.SyncBlockError).EntityNotFound:
            {
                let t8;
                if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8bpSu.SyncedBlockEntityNotFoundError), {});
                    $[14] = t8;
                } else t8 = $[14];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Offline:
            {
                let t8;
                if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1zvH6.SyncedBlockOfflineError), {});
                    $[15] = t8;
                } else t8 = $[15];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Forbidden:
            {
                let t8;
                if ($[16] !== fireAnalyticsEvent || $[17] !== getAccountId || $[18] !== resourceId) {
                    t8 = $2a4f71ad51426bfa$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent, getAccountId);
                    $[16] = fireAnalyticsEvent;
                    $[17] = getAccountId;
                    $[18] = resourceId;
                    $[19] = t8;
                } else t8 = $[19];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).NotFound:
            {
                let t8;
                if ($[20] !== error.reason || $[21] !== error.sourceAri) {
                    t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1TrZ6.SyncedBlockNotFoundError), {
                        reason: error.reason,
                        sourceAri: error.sourceAri
                    });
                    $[20] = error.reason;
                    $[21] = error.sourceAri;
                    $[22] = t8;
                } else t8 = $[22];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Unpublished:
            {
                let t8;
                if ($[23] !== resourceId) {
                    t8 = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
                    $[23] = resourceId;
                    $[24] = t8;
                } else t8 = $[24];
                let t9;
                if ($[25] !== sourceURL || $[26] !== t8) {
                    t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4NWzb.SyncedBlockUnpublishedError), {
                        sourceURL: sourceURL,
                        sourceProduct: t8
                    });
                    $[25] = sourceURL;
                    $[26] = t8;
                    $[27] = t9;
                } else t9 = $[27];
                t7 = t9;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Errored:
        case (0, $79ir6.SyncBlockError).RateLimited:
        case (0, $79ir6.SyncBlockError).ServerError:
            {
                let t8;
                if ($[28] !== isLoading || $[29] !== onRetry) {
                    t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6b2ZK.SyncedBlockLoadError), {
                        onRetry: onRetry,
                        isLoading: isLoading
                    });
                    $[28] = isLoading;
                    $[29] = onRetry;
                    $[30] = t8;
                } else t8 = $[30];
                t7 = t8;
                break bb0;
            }
        default:
            {
                let t8;
                if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cV42A.SyncedBlockGenericError), {});
                    $[31] = t8;
                } else t8 = $[31];
                t7 = t8;
            }
    }
    const getErrorContent = t7;
    let t8;
    if ($[32] !== getErrorContent) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "sync-block-error",
            className: (0, $95bQO.SyncBlockSharedCssClassName).error,
            children: getErrorContent
        });
        $[32] = getErrorContent;
        $[33] = t8;
    } else t8 = $[33];
    return t8;
} : ({ error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent, sourceURL: sourceURL, getAccountId: getAccountId })=>{
    (0, $cozmU.useEffect)(()=>{
        // Emit structured attribution via the shared builder instead of an opaque
        // `errored`-only blob. Prefer the PII-safe `originalMessage` so the classifier
        // can bucket the real cause; fall back to `reason` then the bare `type`.
        const rawError = error?.originalMessage || error?.reason || error?.type || 'unknown';
        fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(`${rawError}: error component rendered`, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(rawError, error?.statusCode)));
    }, [
        error?.originalMessage,
        error?.reason,
        error?.type,
        error?.statusCode,
        resourceId,
        fireAnalyticsEvent
    ]);
    const getErrorContent = (0, $cozmU.useMemo)(()=>{
        switch(error?.type){
            case (0, $79ir6.SyncBlockError).EntityNotFound:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8bpSu.SyncedBlockEntityNotFoundError), {});
            case (0, $79ir6.SyncBlockError).Offline:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1zvH6.SyncedBlockOfflineError), {});
            case (0, $79ir6.SyncBlockError).Forbidden:
                return $2a4f71ad51426bfa$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent, getAccountId);
            case (0, $79ir6.SyncBlockError).NotFound:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1TrZ6.SyncedBlockNotFoundError), {
                    reason: error.reason,
                    sourceAri: error.sourceAri
                });
            case (0, $79ir6.SyncBlockError).Unpublished:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4NWzb.SyncedBlockUnpublishedError), {
                    sourceURL: sourceURL,
                    sourceProduct: (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)
                });
            case (0, $79ir6.SyncBlockError).Errored:
            case (0, $79ir6.SyncBlockError).RateLimited:
            case (0, $79ir6.SyncBlockError).ServerError:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6b2ZK.SyncedBlockLoadError), {
                    onRetry: onRetry,
                    isLoading: isLoading
                });
            default:
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cV42A.SyncedBlockGenericError), {});
        }
    }, [
        error,
        isLoading,
        onRetry,
        resourceId,
        fireAnalyticsEvent,
        sourceURL,
        getAccountId
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "sync-block-error",
        className: (0, $95bQO.SyncBlockSharedCssClassName).error,
        children: getErrorContent
    }));
};
module.exports["SyncedBlockErrorComponent"] = $2a4f71ad51426bfa$export$f4d17ad2341a04f8;

});

parcelRegister("8bpSu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $eO7Q2 = parcelRequire("eO7Q2");


var $8y86q = parcelRequire("8y86q");


var $7vK9E = parcelRequire("7vK9E");


var $3lQHu = parcelRequire("3lQHu");

const $202942cf525bcf92$var$styles = {
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $202942cf525bcf92$export$c15feb10af1ecdbf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).entityNotFoundDescription, {
            link: $202942cf525bcf92$var$_temp
        });
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const description = t0;
    let t1;
    if ($[2] !== description) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: description,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
        });
        $[2] = description;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const description = formatMessage((0, $aI2Eh.syncBlockMessages).entityNotFoundDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $202942cf525bcf92$var$styles.link,
                children: chunks
            })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    });
};
function $202942cf525bcf92$var$_temp(chunks) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
        target: "_blank",
        rel: "noopener noreferrer",
        xcss: $202942cf525bcf92$var$styles.link,
        children: chunks
    });
}
module.exports["SyncedBlockEntityNotFoundError"] = $202942cf525bcf92$export$c15feb10af1ecdbf;

});

parcelRegister("3lQHu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $i1agE = parcelRequire("i1agE");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $72138bd1ab4464da$var$styles = {
    wrapper: "_2mHwu85zaO _4c065UgVvo _0LQT5E5zaO _3iDTPbQ4SZ _37wbyu7p2s _0hPCNLDIqT",
    container: "_3iDTPbQ4SZ"
};
const $72138bd1ab4464da$export$dc0ab13618635cb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, description: description, icon: icon } = t0;
    const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($i1agE)));
    let t1;
    if ($[0] !== Icon) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        });
        $[0] = Icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== description) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: description
        });
        $[2] = description;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $72138bd1ab4464da$var$styles.wrapper,
            children: [
                t1,
                t2
            ]
        });
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== children || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $72138bd1ab4464da$var$styles.container,
            children: [
                t3,
                children
            ]
        });
        $[7] = children;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, description: description, icon: icon })=>{
    const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($i1agE)));
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $72138bd1ab4464da$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $72138bd1ab4464da$var$styles.wrapper,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtle",
                        children: description
                    })
                ]
            }),
            children
        ]
    });
};
module.exports["SyncedBlockErrorStateCard"] = $72138bd1ab4464da$export$dc0ab13618635cb1;

});

parcelRegister("cV42A", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $3lQHu = parcelRequire("3lQHu");

const $1a0d19bd28fd7127$export$59b0b39f63011407 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription)
    });
};
module.exports["SyncedBlockGenericError"] = $1a0d19bd28fd7127$export$59b0b39f63011407;

});

parcelRegister("6b2ZK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $aI2Eh = parcelRequire("aI2Eh");


var $iMnC5 = parcelRequire("iMnC5");


var $3lQHu = parcelRequire("3lQHu");

const $57c81f4ea1b2a29a$var$styles = {
    buttonContainer: "_2XsHFM2ADO _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $57c81f4ea1b2a29a$export$ca85b0be86ccfb26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onRetry: onRetry, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onRetry) {
        t1 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        };
        $[0] = onRetry;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $aI2Eh.syncBlockMessages).retryButton);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isLoading || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "compact",
            onClick: t1,
            isLoading: isLoading,
            testId: "sync-block-retry-btn",
            children: t2
        });
        $[4] = isLoading;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const button = t3;
    let t4;
    if ($[8] !== formatMessage) {
        t4 = formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription);
        $[8] = formatMessage;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== button || $[11] !== onRetry) {
        t5 = onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $57c81f4ea1b2a29a$var$styles.buttonContainer,
            children: button
        });
        $[10] = button;
        $[11] = onRetry;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: t4,
            children: t5
        });
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ onRetry: onRetry, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        },
        isLoading: isLoading,
        testId: "sync-block-retry-btn",
        children: formatMessage((0, $aI2Eh.syncBlockMessages).retryButton)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription),
        children: onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $57c81f4ea1b2a29a$var$styles.buttonContainer,
            children: button
        })
    });
};
module.exports["SyncedBlockLoadError"] = $57c81f4ea1b2a29a$export$ca85b0be86ccfb26;

});

parcelRegister("1TrZ6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $2xhuI = parcelRequire("2xhuI");

var $aI2Eh = parcelRequire("aI2Eh");


var $i2lVL = parcelRequire("i2lVL");


var $l3wuH = parcelRequire("l3wuH");


var $bsSbN = parcelRequire("bsSbN");


var $8y86q = parcelRequire("8y86q");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $3lQHu = parcelRequire("3lQHu");

const $aa923ad5452fda0c$var$styles = {
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
    spinner: "_4c065U8HPE _3iDTPbQ4SZ _37wbyuDIqT",
    closeButton: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _37wbyuz9WS"
};
const $aa923ad5452fda0c$var$errorMap = {
    'source-block-unsynced': {
        description: (0, $aI2Eh.syncBlockMessages).sourceUnsyncedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-block-deleted': {
        description: (0, $aI2Eh.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-block-unpublished': {
        description: (0, $aI2Eh.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-document-deleted': {
        description: (0, $aI2Eh.syncBlockMessages).notFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
    },
    generic: {
        description: (0, $aI2Eh.syncBlockMessages).genericNotFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    }
};
const $aa923ad5452fda0c$var$useErrorInfo = (0, $gtMdU.isReactCompilerActivePlatform)() ? (reason, url, title)=>{
    const $ = (0, $bDgLe.c)(18);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (reason === "source-document-deleted") {
        const { icon: icon, description: description } = $aa923ad5452fda0c$var$errorMap["source-document-deleted"];
        let t0;
        if ($[0] !== formatMessage) {
            t0 = formatMessage(description);
            $[0] = formatMessage;
            $[1] = t0;
        } else t0 = $[1];
        let t1;
        if ($[2] !== t0) {
            t1 = {
                description: t0,
                icon: icon
            };
            $[2] = t0;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    if (!url || !title) {
        const { icon: icon_0, description: description_0 } = $aa923ad5452fda0c$var$errorMap.generic;
        let t0;
        if ($[4] !== formatMessage) {
            t0 = formatMessage(description_0);
            $[4] = formatMessage;
            $[5] = t0;
        } else t0 = $[5];
        let t1;
        if ($[6] !== t0) {
            t1 = {
                description: t0,
                icon: icon_0
            };
            $[6] = t0;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    const { icon: icon_1, description: description_1 } = $aa923ad5452fda0c$var$errorMap[reason || "generic"] ?? $aa923ad5452fda0c$var$errorMap.generic;
    let t0;
    if ($[8] !== url) {
        t0 = (chunk)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: url,
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $aa923ad5452fda0c$var$styles.link,
                children: chunk
            });
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    let t1;
    if ($[10] !== description_1 || $[11] !== formatMessage || $[12] !== t0 || $[13] !== title) {
        t1 = formatMessage(description_1, {
            title: title,
            a: t0
        });
        $[10] = description_1;
        $[11] = formatMessage;
        $[12] = t0;
        $[13] = title;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== icon_1 || $[16] !== t1) {
        t2 = {
            description: t1,
            icon: icon_1
        };
        $[15] = icon_1;
        $[16] = t1;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : (reason, url, title)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (reason === 'source-document-deleted') {
        const { icon: icon, description: description } = $aa923ad5452fda0c$var$errorMap['source-document-deleted'];
        return {
            description: formatMessage(description),
            icon: icon
        };
    }
    if (!url || !title) {
        const { icon: icon_0, description: description_0 } = $aa923ad5452fda0c$var$errorMap['generic'];
        return {
            description: formatMessage(description_0),
            icon: icon_0
        };
    }
    const { icon: icon_1, description: description_1 } = $aa923ad5452fda0c$var$errorMap[reason || 'generic'] ?? $aa923ad5452fda0c$var$errorMap['generic'];
    return {
        description: formatMessage(description_1, {
            title: title,
            a: (chunk)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                    href: url,
                    target: "_blank",
                    rel: 'noopener noreferrer',
                    xcss: $aa923ad5452fda0c$var$styles.link,
                    children: chunk
                })
        }),
        icon: icon_1
    };
};
const $aa923ad5452fda0c$export$3f73b17e61025be6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { reason: t1, sourceAri: sourceAri } = t0;
    const reason = t1 === undefined ? "source-block-deleted" : t1;
    const { deleteSyncBlock: deleteSyncBlock, fetchSourceInfo: fetchSourceInfo } = (0, $i2lVL.useSyncBlockActions)() ?? {};
    const [sourceInfo, setSourceInfo] = (0, $cozmU.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    let t3;
    if ($[0] !== fetchSourceInfo || $[1] !== reason || $[2] !== sourceAri) {
        t2 = ()=>{
            if (!sourceAri || ![
                "source-block-deleted",
                "source-block-unsynced",
                "source-block-unpublished"
            ].includes(reason)) {
                setSourceInfo({});
                return;
            }
            const getSourceInfo = async ()=>{
                const sourceInfo_0 = await fetchSourceInfo?.(sourceAri, true);
                setSourceInfo({
                    url: sourceInfo_0?.url,
                    title: sourceInfo_0?.title
                });
            };
            getSourceInfo();
        };
        t3 = [
            reason,
            sourceAri,
            fetchSourceInfo
        ];
        $[0] = fetchSourceInfo;
        $[1] = reason;
        $[2] = sourceAri;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const { description: description, icon: icon } = $aa923ad5452fda0c$var$useErrorInfo(reason, sourceInfo?.url, sourceInfo?.title);
    let t4;
    if ($[5] !== deleteSyncBlock || $[6] !== description || $[7] !== formatMessage || $[8] !== icon || $[9] !== sourceInfo) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: sourceInfo === undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $aa923ad5452fda0c$var$styles.spinner,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
                description: description,
                icon: icon,
                children: deleteSyncBlock && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $aa923ad5452fda0c$var$styles.closeButton,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                        label: formatMessage((0, $2xhuI.default).delete),
                        onClick: deleteSyncBlock
                    })
                })
            })
        });
        $[5] = deleteSyncBlock;
        $[6] = description;
        $[7] = formatMessage;
        $[8] = icon;
        $[9] = sourceInfo;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ reason: reason = 'source-block-deleted', sourceAri: sourceAri })=>{
    const { deleteSyncBlock: deleteSyncBlock, fetchSourceInfo: fetchSourceInfo } = (0, $i2lVL.useSyncBlockActions)() ?? {};
    const [sourceInfo, setSourceInfo] = (0, $cozmU.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (!sourceAri || // Only fetch source info for these 3 cases
        ![
            'source-block-deleted',
            'source-block-unsynced',
            'source-block-unpublished'
        ].includes(reason)) {
            setSourceInfo({});
            return;
        }
        const getSourceInfo = async ()=>{
            const sourceInfo_0 = await fetchSourceInfo?.(sourceAri, true);
            setSourceInfo({
                url: sourceInfo_0?.url,
                title: sourceInfo_0?.title
            });
        };
        getSourceInfo();
    }, [
        reason,
        sourceAri,
        fetchSourceInfo
    ]);
    const { description: description, icon: icon } = $aa923ad5452fda0c$var$useErrorInfo(reason, sourceInfo?.url, sourceInfo?.title);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: sourceInfo === undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $aa923ad5452fda0c$var$styles.spinner,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: description,
            icon: icon,
            children: deleteSyncBlock && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $aa923ad5452fda0c$var$styles.closeButton,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                    label: formatMessage((0, $2xhuI.default).delete),
                    onClick: deleteSyncBlock
                })
            })
        })
    });
};
module.exports["SyncedBlockNotFoundError"] = $aa923ad5452fda0c$export$3f73b17e61025be6;

});

parcelRegister("1zvH6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $3lQHu = parcelRequire("3lQHu");

const $5d62db625936e51f$export$8a461f6033aecd80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).offlineError);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).offlineError)
    });
};
module.exports["SyncedBlockOfflineError"] = $5d62db625936e51f$export$8a461f6033aecd80;

});

parcelRegister("evEE0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $7bDU0 = parcelRequire("7bDU0");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $ad7Ou = parcelRequire("ad7Ou");


var $aI2Eh = parcelRequire("aI2Eh");


var $aQ2DA = parcelRequire("aQ2DA");


var $I7hWB = parcelRequire("I7hWB");


var $chu6R = parcelRequire("chu6R");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $7UDEf = parcelRequire("7UDEf");


var $cV42A = parcelRequire("cV42A");

const $b7d8f9d435e66778$var$styles = {
    wrapper: "_2mHwu85zaO _0Of8r2kG2W _1wydGWkG2W _2Zuz6QkG2W _1ZnuxbkG2W _3iDTPbQ4SZ _37wbyu7p2s _0hPCNLDIqT"
};
var $b7d8f9d435e66778$var$RequestAccessState = /*#__PURE__*/ function(RequestAccessState) {
    RequestAccessState["default"] = "default";
    RequestAccessState["errored"] = "errored";
    RequestAccessState["loading"] = "loading";
    RequestAccessState["pending"] = "pending";
    return RequestAccessState;
}($b7d8f9d435e66778$var$RequestAccessState || {});
const $b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { sourceContentId: sourceContentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRequestAccessState("pending");
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleRequestComplete = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setRequestAccessState("errored");
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleRequestError = t2;
    const [commitMutation] = (0, $6SsN4.useMutation)((0, $7bDU0.default));
    let t3;
    if ($[2] !== commitMutation || $[3] !== sourceContentId) {
        t3 = ()=>{
            setRequestAccessState("loading");
            commitMutation({
                variables: {
                    requestPageAccessInput: {
                        pageId: sourceContentId,
                        accessType: "VIEW"
                    }
                },
                onCompleted: ()=>{
                    handleRequestComplete();
                },
                onError: handleRequestError
            });
        };
        $[2] = commitMutation;
        $[3] = sourceContentId;
        $[4] = t3;
    } else t3 = $[4];
    const onClick = t3;
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7UDEf))),
            alt: t4,
            width: "48",
            height: "48"
        });
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
            size: "xsmall",
            children: t6
        });
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== formatMessage) {
        t8 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription);
        $[13] = formatMessage;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: t8
        });
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage || $[18] !== onClick || $[19] !== requestAccessState) {
        t10 = requestAccessState === "pending" ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            columnGap: "space.050",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                    size: "small",
                    color: "var(--ds-icon-subtle, #505258)",
                    label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    weight: "bold",
                    testId: "sync-block-access-requested-msg",
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            columnGap: "space.100",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                    appearance: "default",
                    spacing: "compact",
                    onClick: onClick,
                    isLoading: requestAccessState === "loading",
                    testId: "sync-block-request-access-btn",
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)
                }),
                requestAccessState === "errored" && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.warning",
                    testId: "sync-block-access-error-msg",
                    children: formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessError)
                })
            ]
        });
        $[17] = formatMessage;
        $[18] = onClick;
        $[19] = requestAccessState;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t7 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.100",
            children: [
                t7,
                t9,
                t10
            ]
        });
        $[21] = t10;
        $[22] = t7;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t5) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: $b7d8f9d435e66778$var$styles.wrapper,
            children: [
                t5,
                t11
            ]
        });
        $[25] = t11;
        $[26] = t5;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ sourceContentId: sourceContentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    const handleRequestComplete = ()=>{
        setRequestAccessState("pending");
    };
    const handleRequestError = ()=>{
        setRequestAccessState("errored");
    };
    const [commitMutation] = (0, $6SsN4.useMutation)((0, $7bDU0.default));
    const onClick = ()=>{
        setRequestAccessState("loading");
        commitMutation({
            variables: {
                requestPageAccessInput: {
                    pageId: sourceContentId,
                    accessType: 'VIEW'
                }
            },
            onCompleted: ()=>{
                handleRequestComplete();
            },
            onError: handleRequestError
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $b7d8f9d435e66778$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7UDEf))),
                alt: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText),
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "xsmall",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription)
                    }),
                    requestAccessState === "pending" ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        columnGap: "space.050",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                                size: "small",
                                color: "var(--ds-icon-subtle, #505258)",
                                label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                weight: "bold",
                                testId: "sync-block-access-requested-msg",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        columnGap: "space.100",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                appearance: "default",
                                spacing: "compact",
                                onClick: onClick,
                                isLoading: requestAccessState === "loading",
                                testId: "sync-block-request-access-btn",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)
                            }),
                            requestAccessState === "errored" && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.warning",
                                testId: "sync-block-access-error-msg",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessError)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem = ({ sourceContentId: sourceContentId, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    const onClick = (0, $cozmU.useCallback)(async ()=>{
        setRequestAccessState("loading"); // Fire and forget. Per the Jira backend contract the response is
        // intentionally opaque (empty 204 on success, generic on failure) to
        // prevent issue-existence enumeration. We always end in `pending`.
        try {
            await (0, $aQ2DA.requestJiraSpaceAccess)({
                accountId: accountId,
                issueId: Number(sourceContentId) || null,
                projectKey: null
            });
        } catch (_e) {}
        setRequestAccessState("pending");
    }, [
        accountId,
        sourceContentId
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $b7d8f9d435e66778$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7UDEf))),
                alt: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText),
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "xsmall",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription)
                    }),
                    requestAccessState === "pending" ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                        columnGap: "space.050",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                                size: "small",
                                color: "var(--ds-icon-subtle, #505258)",
                                label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                weight: "bold",
                                testId: "sync-block-access-requested-msg",
                                children: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                        columnGap: "space.100",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "default",
                            spacing: "compact",
                            onClick: onClick,
                            isLoading: requestAccessState === "loading",
                            testId: "sync-block-request-access-btn",
                            children: formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)
                        })
                    })
                ]
            })
        ]
    });
};
const $b7d8f9d435e66778$export$33325aff698460b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { sourceContentId: sourceContentId, sourceProduct: sourceProduct, accountId: accountId } = t0;
    switch(sourceProduct){
        case "confluence-page":
            {
                let t1;
                if ($[0] !== sourceContentId) {
                    t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage, {
                        sourceContentId: sourceContentId
                    });
                    $[0] = sourceContentId;
                    $[1] = t1;
                } else t1 = $[1];
                return t1;
            }
        case "jira-work-item":
            {
                let t1;
                if ($[2] !== accountId || $[3] !== sourceContentId) {
                    t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem, {
                        sourceContentId: sourceContentId,
                        accountId: accountId
                    });
                    $[2] = accountId;
                    $[3] = sourceContentId;
                    $[4] = t1;
                } else t1 = $[4];
                return t1;
            }
        default:
            {
                let t1;
                if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cV42A.SyncedBlockGenericError), {});
                    $[5] = t1;
                } else t1 = $[5];
                return t1;
            }
    }
} : ({ sourceContentId: sourceContentId, sourceProduct: sourceProduct, accountId: accountId })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return /*#__PURE__*/ (0, $8aG6j.jsx)($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage, {
                sourceContentId: sourceContentId
            });
        case 'jira-work-item':
            return /*#__PURE__*/ (0, $8aG6j.jsx)($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem, {
                sourceContentId: sourceContentId,
                accountId: accountId
            });
        default:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cV42A.SyncedBlockGenericError), {});
    }
};
module.exports["SyncedBlockPermissionDenied"] = $b7d8f9d435e66778$export$33325aff698460b9;

});

parcelRegister("7bDU0", function(module, exports) {
/**
 * @generated SignedSource<<0c6c51fca90b1d8be221569188b41155>>
 * @relayHash 676631e44ffd7d0d16b3a7e96ba02def
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d
const $eb40956e546afb46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d",
            "metadata": {},
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$eb40956e546afb46$var$node.hash = "d0d4982ad805583380d2436a8e21ee6a";
var $eb40956e546afb46$export$2e2bcd8739ae039 = $eb40956e546afb46$var$node;
module.exports["default"] = $eb40956e546afb46$export$2e2bcd8739ae039;

});

parcelRegister("aQ2DA", function(module, exports) {
/**
 * Sends a "request access" notification for a Jira work item the current viewer
 * cannot see. A copy of jira/src/packages/platform/space-not-found-with-request-access/src/requestSpaceAccess.tsx
 */ const $13f179472afcb5ea$var$REQUEST_ACCESS_URL = '/rest/internal/latest/project-access/access-requested';
const $13f179472afcb5ea$export$47e85d58c126fc4d = (payload)=>{
    // we return nothing on purpose to be vague, not disclose if the project exists or not,
    // so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
    return fetch($13f179472afcb5ea$var$REQUEST_ACCESS_URL, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
};
module.exports["requestJiraSpaceAccess"] = $13f179472afcb5ea$export$47e85d58c126fc4d;

});

parcelRegister("7UDEf", function(module, exports) {
module.exports = new URL("PermissionDenied.bfcb6211.svg", import.meta.url).toString();

});

parcelRegister("4NWzb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $bsSbN = parcelRequire("bsSbN");


var $7vK9E = parcelRequire("7vK9E");


var $3lQHu = parcelRequire("3lQHu");

const $a4467333f2a8d6b8$var$styles = {
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $a4467333f2a8d6b8$export$a78c0479e6ca5528 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { sourceURL: sourceURL, sourceProduct: sourceProduct } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = sourceProduct === "jira-work-item" ? (0, $aI2Eh.syncBlockMessages).unpublishedErrorJiraWorkItem : (0, $aI2Eh.syncBlockMessages).unpublishedError;
    let t1;
    if ($[0] !== sourceURL) {
        t1 = (chunks)=>sourceURL ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: sourceURL,
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $a4467333f2a8d6b8$var$styles.link,
                children: chunks
            }) : chunks;
        $[0] = sourceURL;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage || $[3] !== message || $[4] !== t1) {
        t2 = formatMessage(message, {
            link: t1
        });
        $[2] = formatMessage;
        $[3] = message;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== description) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
            description: description,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
        });
        $[6] = description;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ sourceURL: sourceURL, sourceProduct: sourceProduct })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // Pick the product-specific copy. Jira work items are described as "the item's
    // description is saved" rather than "the page is published" because Jira issues
    // don't have a page-level publish action — the description field is what's
    // being authored.
    const message = sourceProduct === 'jira-work-item' ? (0, $aI2Eh.syncBlockMessages).unpublishedErrorJiraWorkItem : (0, $aI2Eh.syncBlockMessages).unpublishedError;
    const description = formatMessage(message, {
        link: (chunks)=>sourceURL ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: sourceURL,
                target: "_blank",
                rel: 'noopener noreferrer',
                xcss: $a4467333f2a8d6b8$var$styles.link,
                children: chunks
            }) : chunks
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3lQHu.SyncedBlockErrorStateCard), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
    });
};
module.exports["SyncedBlockUnpublishedError"] = $a4467333f2a8d6b8$export$a78c0479e6ca5528;

});

parcelRegister("4Hfg5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $95bQO = parcelRequire("95bQO");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");

const $200d4e51d938dcb9$var$styles = {
    wrapper: "_4kiQYA9LX5 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
};
const $200d4e51d938dcb9$export$6d2e5b4986b73a9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).loadingSyncedContent);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $95bQO.SyncBlockSharedCssClassName).loading,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $200d4e51d938dcb9$var$styles.wrapper,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                    size: "small",
                    label: t0
                })
            })
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $95bQO.SyncBlockSharedCssClassName).loading,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $200d4e51d938dcb9$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: formatMessage((0, $aI2Eh.syncBlockMessages).loadingSyncedContent)
            })
        })
    }));
};
module.exports["SyncedBlockLoadingState"] = $200d4e51d938dcb9$export$6d2e5b4986b73a9a;

});

parcelRegister("gsPOZ", function(module, exports) {

var $8GUnx = parcelRequire("8GUnx");


var $eqEJl = parcelRequire("eqEJl");


var $3xsB6 = parcelRequire("3xsB6");


var $9HB34 = parcelRequire("9HB34");

/**
 * Converts a Relay subscription response to SyncBlockInstance format.
 */ function $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response, resourceId) {
    let createdAt;
    if (response.createdAt !== undefined && response.createdAt !== null) try {
        createdAt = new Date(response.createdAt).toISOString();
    } catch  {
        createdAt = undefined;
    }
    let contentUpdatedAt;
    if (response.contentUpdatedAt !== undefined && response.contentUpdatedAt !== null) try {
        contentUpdatedAt = new Date(response.contentUpdatedAt).toISOString();
    } catch  {
        contentUpdatedAt = undefined;
    }
    return {
        data: {
            content: JSON.parse(response.content),
            contentUpdatedAt: contentUpdatedAt,
            resourceId: response.blockAri,
            blockInstanceId: response.blockInstanceId,
            sourceAri: response.sourceAri,
            product: response.product,
            createdAt: createdAt,
            createdBy: response.createdBy,
            status: response.status
        },
        resourceId: resourceId
    };
}
function $8642b45e2aee2bb6$export$7a629188ade23de0(baseProvider, cloudId) {
    const subscription = (0, $8GUnx.default);
    // Create a new provider that preserves all methods from baseProvider
    // Preserve the prototype chain to ensure all methods are accessible
    const wrappedProvider = Object.create(Object.getPrototypeOf(baseProvider));
    Object.assign(wrappedProvider, baseProvider);
    // Override subscribeToBlockUpdates with Relay subscription support
    wrappedProvider.subscribeToBlockUpdates = function(resourceId, onUpdate, onError, onComplete) {
        // Get the Relay environment — returns null when SSR or tests haven't initialised it.
        const environment = (0, $9HB34.getRelayEnvironment)();
        if (!environment) {
            onError?.(new Error('Relay environment not available'));
            return ()=>{};
        }
        // Convert resourceId to blockAri for the subscription
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: cloudId,
            resourceId: resourceId
        });
        let disposable = null;
        try {
            disposable = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: {
                    resourceId: blockAri
                },
                onNext: (response)=>{
                    if (response?.blockService_onBlockUpdated) {
                        const syncBlockInstance = $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response.blockService_onBlockUpdated, resourceId);
                        onUpdate(syncBlockInstance);
                    }
                },
                onError: (error)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    onError?.(error);
                },
                onCompleted: ()=>{
                    onComplete?.();
                }
            });
        } catch (error) {
            onError?.(error instanceof Error ? error : new Error(String(error)));
            // Return a no-op unsubscribe if subscription fails
            return ()=>{};
        }
        return ()=>{
            if (disposable) disposable.dispose();
        };
    };
    return wrappedProvider;
}
module.exports["createRelaySyncBlockFetchProvider"] = $8642b45e2aee2bb6$export$7a629188ade23de0;

});

parcelRegister("8GUnx", function(module, exports) {
/**
 * @generated SignedSource<<eba967ef43ce0005d9aebfc0d15e70bc>>
 * @relayHash 3e442d5d3227540b5f9648827533c2f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd
const $11aa77d8f290fc7b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "BlockServiceBlockPayload",
            "kind": "LinkedField",
            "name": "blockService_onBlockUpdated",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "blockAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "blockInstanceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentUpdatedAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdBy"
                },
                {
                    "kind": "ScalarField",
                    "name": "deletionReason"
                },
                {
                    "kind": "ScalarField",
                    "name": "product"
                },
                {
                    "kind": "ScalarField",
                    "name": "sourceAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e442d5d3227540b5f9648827533c2f8",
            "id": "cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd",
            "metadata": {},
            "name": "relaySyncBlockFetchProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription relaySyncBlockFetchProviderSubscription($resourceId:ID!){blockService_onBlockUpdated(resourceId:$resourceId){blockAri,blockInstanceId,content,contentUpdatedAt,createdAt,createdBy,deletionReason,product,sourceAri,status}}"
        }
    };
}();
$11aa77d8f290fc7b$var$node.hash = "f3661ea7b2ab697a90b3ec5ef8d55382";
var $11aa77d8f290fc7b$export$2e2bcd8739ae039 = $11aa77d8f290fc7b$var$node;
module.exports["default"] = $11aa77d8f290fc7b$export$2e2bcd8739ae039;

});

parcelRegister("kr7vV", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $4iyA6 = parcelRequire("4iyA6");

const $8b8ae4c054fbf670$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $4iyA6.smartCardEventHandler)(routesContext, e, url)
        },
        link: {
            onClick: (e, url)=>(0, $4iyA6.smartCardEventHandler)(routesContext, e, url)
        }
    } : undefined);
module.exports["createSmartCardEventHandler"] = $8b8ae4c054fbf670$export$f996105bf70a5c25;

});

parcelRegister("4iyA6", function(module, exports) {

var $dHSeC = parcelRequire("dHSeC");


var $aO580 = parcelRequire("aO580");


var $2xqog = parcelRequire("2xqog");


var $3cDja = parcelRequire("3cDja");

const $8cc710eb1f83f98d$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $2xqog.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $3cDja.isExternalShareRequest)());
    } else $8cc710eb1f83f98d$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $8cc710eb1f83f98d$var$handleClick = (e, url)=>{
    (0, $aO580.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $8cc710eb1f83f98d$export$71eec072841e6b90;

});

parcelRegister("aO580", function(module, exports) {
const $70b9b34c85768a23$export$4128d9964cdd56b5 = (e, { shouldCheckIframe: shouldCheckIframe = false } = {})=>{
    const { metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = e.nativeEvent;
    const hasModifierKeyPressed = metaKey || ctrlKey || shiftKey;
    const isInIframe = shouldCheckIframe ? window.top !== window : false;
    return hasModifierKeyPressed || isInIframe;
};
module.exports["isClickEventToOpenNewTab"] = $70b9b34c85768a23$export$4128d9964cdd56b5;

});

parcelRegister("2xqog", function(module, exports) {
/**
 * Duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/isExternalLink.ts
 */ const $f3e762af8cd6ff89$export$b98882f166bb7ce2 = (url)=>{
    if (!url) return false;
    try {
        const urlObj = new URL(url, window.location.origin);
        return urlObj.origin !== window.location.origin;
    } catch  {
        return false;
    }
};
module.exports["isExternalLink"] = $f3e762af8cd6ff89$export$b98882f166bb7ce2;

});

parcelRegister("3cDja", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $afbbb35f90e71c1c$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $afbbb35f90e71c1c$export$50d92d69a5c05c70;

});

parcelRegister("epn2u", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $950ecc7cad6e8d10$export$e09386e914855e84 = ()=>{
    // Fire a client-side exposure for the SSR preload experiment. The experiment is only
    // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
    // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
    // point where the SSR-preloaded sync block data is consumed on the client — ensures every
    // page load records an exposure, allowing us to measure the experiment's effect accurately.
    // Once the optimal value is found, this will be converted to a permanent Statsig config.
    (0, $6mKj3.manuallyLogExpExposure)('platform_editor_sync_block_ssr_config');
    const rawSyncBlockData = typeof globalThis !== 'undefined' ? globalThis.__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks : undefined;
    if (rawSyncBlockData) return rawSyncBlockData.reduce((acc, item)=>{
        acc[item.resourceId] = item;
        return acc;
    }, {});
    return undefined;
};
module.exports["syncedBlockLoadSSRData"] = $950ecc7cad6e8d10$export$e09386e914855e84;

});


$parcel$global.rlb("kYlwR")
//# sourceMappingURL=CommentsPanelWrapper.84950371.js.map
